import React from 'react';

export const ConfirmSignInWithCustomChallenge: React.FC = () => {
  return (
    <>
      <p>Not Implemented - ConfirmSignInWithCustomChallenge</p>
    </>
  );
};
